<template>
  <div>
    <div class="container-md plr-0">
      <div class="container-bg p-4 pright-g">
        <h3>Abonnementen</h3>
        <div class="row">
          <div class="col-6 mt-3">
            <b>Abonnementen</b>
          </div>
          <div class="col-6 mt-3">
            <p
              class="float-right"
              data-toggle="modal"
              data-target="#modalSubscription"
              @click="initModal(0)"
            >
              <i
                class="fa fa-plus"
                style="font-size: 24px; cursor: pointer"
              ></i>
            </p>
          </div>
        </div>

        <div
          class="flex-container flex-body pl-md-4 pr-md-4 mt-3"
          v-for="(subscription, index) in subscriptions_all"
          :key="'subscription_' + index"
        >
          <div class="item" style="flex: 2 0 30%">
            <p class="text-white">
              <b>{{ subscription.title }}:</b> {{ subscription.description }}
            </p>
          </div>
          <div class="item text-white text-center">
            <h5>
              <span>{{ subscription.amount_value | priceFormat }}</span>
              / <span v-if="subscription.interval == '1 month'">Maand</span
              ><span v-if="subscription.interval == '3 months'">Kwartaal</span
              ><span v-if="subscription.interval == '6 months'">Half jaar</span
              ><span v-if="subscription.interval == '1 year'">Jaar</span>
            </h5>
            <p>
              Status: <span v-if="subscription.status == 1">Actief</span
              ><span v-else>Inactief</span>
            </p>
          </div>
          <div class="item text-white text-center">
            <button
              class="btn btn-dark"
              data-toggle="modal"
              data-target="#modalSubscription"
              @click="getSubscription(subscription.id)"
            >
              Beheer
            </button>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-6">
            <b>Korting Abonnementen</b>
          </div>
          <div class="col-6">
            <p
              class="float-right"
              data-toggle="modal"
              data-target="#modalSubscription"
              @click="initModal(1)"
            >
              <i
                class="fa fa-plus"
                style="font-size: 24px; cursor: pointer"
              ></i>
            </p>
          </div>
        </div>

        <div
          class="flex-container flex-body pl-md-4 pr-md-4 mt-3"
          v-for="(subscription, index) in subscriptions_discount"
          :key="'subscription_discount_' + index"
        >
          <div class="item" style="flex: 2 0 30%">
            <p class="text-white">
              <b>{{ subscription.title }}:</b>{{ subscription.description }}
            </p>
          </div>
          <div class="item text-white text-center">
            <h5>
              <span>{{ subscription.amount_value | priceFormat }}</span>
              / <span v-if="subscription.interval == '1 month'">Maand</span
              ><span v-if="subscription.interval == '3 months'">Kwartaal</span
              ><span v-if="subscription.interval == '6 months'">Half jaar</span
              ><span v-if="subscription.interval == '1 year'">Jaar</span>
            </h5>
            <p>
              Status: <span v-if="subscription.status == 1">Actief</span
              ><span v-else>Inactief</span>
            </p>
          </div>
          <div class="item text-white text-center">
            <button
              class="btn btn-dark"
              data-toggle="modal"
              data-target="#modalSubscription"
              @click="getSubscription(subscription.id)"
            >
              Beheer
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--subscription modal start-->
    <div
      class="modal fade"
      id="modalSubscription"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row" v-if="!item.loading">
              <div class="col-md-8 col-12 pl-md-5 pr-md-5">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <h5 class="text-uppercase" v-if="item.id">
                      Abonnement Beheren
                    </h5>
                    <h5 class="text-uppercase" v-else>Nieuw Abonnement</h5>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Naam:</label>
                      <input
                        type="text"
                        class="form-control"
                        id="name"
                        v-model="item.title"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="textarea">Omschrijving:</label>
                      <editor
                        id="textarea"
                        :v-model="item.description"
                        :init="{
                          height: 200,
                          menubar: false,
                          language: 'nl',
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                                                    alignleft aligncenter alignright alignjustify | \
                                                    bullist numlist outdent indent | removeformat | help',
                        }"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-3">
                        <label>Interval:</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-check form-check-inline ml-4">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="Month"
                            true-value="1 month"
                            v-model="item.interval"
                          />
                          <label class="form-check-label" for="Month"
                            >Maand</label
                          >
                        </div>
                        <div class="form-check form-check-inline ml-4">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="Quarter"
                            true-value="3 months"
                            v-model="item.interval"
                          />
                          <label class="form-check-label" for="Quarter"
                            >Kwartaal</label
                          >
                        </div>
                        <div class="form-check form-check-inline ml-4">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="Year"
                            true-value="1 year"
                            v-model="item.interval"
                          />
                          <label class="form-check-label" for="Year"
                            >Jaar</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-3">
                        <label>Incasso:</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-check form-check-inline ml-4">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="active"
                            value="1"
                            v-model="item.payment_upfront"
                          />
                          <label class="form-check-label" for="active"
                            >Vooraf</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-3">
                        <label>Incasso dag:</label>
                      </div>
                      <div class="col-md-9">
                        <select v-model="item.payment_day" class="form-control">
                          <option
                            v-for="day in 31"
                            :key="'day_' + day"
                            :value="day"
                          >
                            {{ day }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-3">
                        <label>Status:</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-check form-check-inline ml-4">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="active"
                            value="1"
                            v-model="item.status"
                          />
                          <label class="form-check-label" for="active"
                            >Actief</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-3">
                        <label>Korting:</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-check form-check-inline ml-4">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="active"
                            value="1"
                            v-model="item.discount"
                          />
                          <label class="form-check-label" for="active"
                            >Korting</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-3">
                        <label v-if="item.discount">Korting:</label>
                        <label v-else>Prijs:</label>
                      </div>
                      <div class="col-md-9">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1"
                              >€</span
                            >
                          </div>
                          <input
                            type="number"
                            step="0.01"
                            class="form-control"
                            v-model="item.amount_value"
                            aria-describedby="basic-addon1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-3">
                        <label>BTW:</label>
                      </div>
                      <div class="col-md-9">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1"
                              >%</span
                            >
                          </div>
                          <input
                            type="number"
                            step="0.01"
                            class="form-control"
                            v-model="item.vat"
                            aria-describedby="basic-addon1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12">
                        <label
                          >Aantal keer herhalen (laat leeg voor doorlopende
                          incasso):</label
                        >
                      </div>
                      <div class="col-md-12">
                        <div class="input-group mb-3">
                          <input
                            type="number"
                            step="1"
                            class="form-control"
                            v-model="item.times"
                            aria-describedby="basic-addon1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-12 pl-md-2 pr-md-5">
                <div class="row">
                  <div class="col-md-12 mt-3">
                    <button
                      class="btn btn-dark text-white float-right"
                      v-if="item.id"
                      @click="store()"
                    >
                      Opslaan
                    </button>
                    <button
                      class="btn btn-dark text-white float-right"
                      v-else
                      @click="store()"
                    >
                      Aanmaken
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-md-12 mb-3">
                <h5 class="text-uppercase">Aan het laden</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- subscription modal end-->
  </div>
</template>

<script>
export default {
  name: "subscription",
  data() {
    return {
      item: {
        loading: false,
        id: false,
        title: "",
        description: "",
        interval: "",
        status: 1,
        discount: "",
        amount_value: "",
        vat: 21,
        times: "",
        custom: 0,
      },
      subscriptions: [],
    };
  },
  computed: {
    subscriptions_all() {
      return this.subscriptions.filter(
        (subscription) => subscription.discount == 0
      );
    },
    subscriptions_discount() {
      return this.subscriptions.filter(
        (subscription) => subscription.discount == 1
      );
    },
  },
  filters: {
    priceFormat: function (value) {
      let i = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR",
      }).format(value);
      return i;
    },
  },
  methods: {
    getSubscription(id) {
      if (id == false) {
        this.item = {
          loading: false,
          id: false,
          title: "",
          description: "",
          interval: "",
          status: 1,
          discount: "",
          amount_value: "",
          vat: 21,
          times: "",
          custom: 0,
        };
      } else {
        this.item = {
          loading: true,
          id: false,
          title: "",
          description: "",
          interval: "",
          status: 1,
          discount: "",
          amount_value: "",
          vat: 21,
          times: "",
          custom: 0,
        };

        this.$store
          .dispatch("get", "api/v1/subscriptions/" + id)
          .then((data) => {
            this.item = data.data.data;
            this.item.loading = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    store() {
      if (this.item.id) {
        this.$store
          .dispatch("put", {
            endpoint: "api/v1/subscriptions/" + this.item.id,
            details: this.item,
          })
          .then(() => {
            window.location.href = "/settings/subscriptions";
          })
          .catch((error) => {
            if (error.request.status == 422) {
              var response = JSON.parse(error.request.response).errors;
              for (var err in response) {
                this.error = response[err][0];
              }
            }
          });
      } else {
        this.$store
          .dispatch("post", {
            endpoint: "api/v1/subscriptions",
            details: this.item,
          })
          .then(() => {
            window.location.href = "/settings/subscriptions";
          })
          .catch((error) => {
            if (error.request.status == 422) {
              var response = JSON.parse(error.request.response).errors;
              for (var err in response) {
                this.error = response[err][0];
              }
            }
          });
      }
    },
    initModal(discount) {
      if (discount == 0) {
        this.item = {
          loading: false,
          id: false,
          title: "",
          description: "",
          interval: "1 month",
          status: 1,
          discount: "",
          amount_value: "",
          payment_day: 1,
          vat: 21,
          times: "",
          custom: 0,
        };
      } else {
        this.item = {
          loading: false,
          id: false,
          title: "",
          description: "",
          interval: "1 month",
          status: 1,
          discount: 1,
          amount_value: "",
          payment_day: 1,
          vat: 21,
          times: "",
          custom: 0,
        };
      }
    },
  },
  created() {
    this.$store
      .dispatch("get", "api/v1/subscriptions")
      .then((data) => {
        this.subscriptions = data.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;

  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 11%;

  height: auto;
  margin: 4px;
  padding: 20px 0;
  width: auto;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 900px;
    margin: 1.75rem auto;
    margin-top: 9rem;
  }

  .discount-modal {
    max-width: 600px !important;
    margin: 1.75rem auto;
  }
}

.form-control,
.input-group-text {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 4px;
  opacity: 1;
  border: 1px #ced4da;
}

.custom-scrollbar {
  overflow-y: scroll;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f4f5f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 3px;
  background-color: #f5f5f5;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #4192d9 0% 0% no-repeat padding-box;
  border-radius: 5px;
}
</style>
